// CRUD actions are role grants. Workflow actions also require the server policy
// capability; their retired role flags must neither grant nor veto that capability.
export const STOCK_POLICY_ACTIONS = {
  requisitions: ["submit", "approve", "recall"],
  dispatched: ["dispatch", "finalize", "cancel"],
  transfers: ["approve", "dispatch", "cancel"],
};
export function hasPurchasingStockPermission(user, permission) {
  return Number(user?.id) === 1 || user?.permissions?.[permission] === true;
}

export function hasInventoryCountPermission(user, action = "view") {
  if (action === "view") {
    return hasPurchasingStockPermission(user, "purchasing.stock.inventory_count") ||
      hasPurchasingStockPermission(user, "purchasing.stock.inventory_count.view_all");
  }
  return hasPurchasingStockPermission(user, `purchasing.stock.inventory_count.${action}`);
}

export function hasStockOperationPermission(user, workspace, action = "view") {
  const base = `purchasing.stock.${workspace}`;
  return hasPurchasingStockPermission(user, base) &&
    (action === "view" || STOCK_POLICY_ACTIONS[workspace]?.includes(action) || hasPurchasingStockPermission(user, `${base}.${action}`));
}
